import React from 'react'
import './AdBillingStyle.css'

const AdBillingchart = () => {
    return (
        <div className='Allcardboxwrapper AdBillingCartwrap'>
            <div className="borderround">
                <div className="Logoareabilling">
                    <img src="/assets/svg/Logo.svg" alt="" />
                    <div className='Adbillingdata'>
                        <div className="invoicAddata flex">
                            <h4 className='text3'>Invoice No:</h4>
                            <p className='text3'> #INV0034</p>
                        </div>
                        <div className="invoicAddata flex">
                            <h4 className='text3'>Issued On:</h4>
                            <p className='text3'> 27/03/2023</p>
                        </div>
                    </div>
                </div>

                <div className="AccBankAdDetails">
                    <div>
                        <h3 className='signatue'>Invoice From</h3>
                        <ul>
                            <li className='text3'>Shanti Informatics</li>
                            <li className='text3'>Ground Floor, Tower C, DLF Cyber Park,</li>
                            <li className='text3'>Parcel of land at Plot No. 405 B,</li>
                            <li className='text3'>Sector 20, Udhyog Vihar Phase III</li>
                            <li className='text3'>Gurgaon,Haryana, 122008</li>
                        </ul>
                    </div>
                    <div className="InvoiceFromAdds">
                        <h3 className='signatue'>Bill To</h3>
                        <ul>
                            <li className='text3'>Nimisha Shrivastava</li>
                            <li className='text3'>299, Start Trek Drive, Panama City,</li>
                            <li className='text3'>Goa, 324002, India</li>
                            <li className='text3'>nimishashrivastava2203@gmail.com</li>
                            <li className='text3'>+91 98765 432 10</li>
                        </ul>
                    </div>
                </div>

                <div className="AccBankAdDetails">
                    <div>
                        <h3 className='signatue'>Bank Account Details</h3>
                        <ul>
                            <li className='text3'>Bank Name</li>
                            <li className='text3'>Account Number</li>
                            <li className='text3'>IFSC Code</li>
                            <li className='text3'>PAN Card Number</li>
                        </ul>
                    </div>
                </div>

                <div className='CallHistoryTabledata commonTableWrapper'>
                    <table className='TableBackAddetails'>

                        <thead>
                            <tr className='headingTabletr'>
                                <th>Description</th>
                                <th>No. of Hours</th>
                                <th>Cost per hour</th>
                                <th>Amount</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>
                                    <div className="tableBox">
                                        <h4>Student Mentorship Session</h4>
                                    </div>
                                </td>
                                <td>
                                    <div className="tableBox">
                                        <h4>3</h4>
                                    </div>
                                </td>
                                <td>
                                    <div className='tableBox'>
                                        <h4>2000</h4>
                                    </div>
                                </td>
                                <td>
                                    <div className='tableBox dsblock'>
                                        <h4>₹ 6000</h4>
                                    </div>
                                </td>
                            </tr>

                            <tr className='colspanrow'>
                                <td></td>
                                <td></td>
                                <td>Total Amount</td>
                                <td>₹ 6000</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h4 className='signatue'>Signatures</h4>
            </div>
        </div>
    )
}

export default AdBillingchart